import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Download, Zap, Check, Sparkles, RefreshCw, Infinity as InfinityIcon } from 'lucide-react';
import { DigitalDisclaimer } from './DigitalDisclaimer';
export function Hero() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank', 'noopener,noreferrer');
  };
  const bullets = ['Aprende Amazon FBA y FBM desde cero', 'Aprende a usar Seller Central correctamente', 'Aprende a publicar productos reales', 'Descubre cómo encontrar productos rentables', 'Aprende campañas publicitarias dentro de Amazon', 'Sistema práctico y fácil de entender', 'Diseñado especialmente para principiantes'];
  return <section className="bg-brand-white pt-20 pb-16 md:pt-32 md:pb-28 px-5 sm:px-6 overflow-hidden relative" data-id="element-298">
      {/* Subtle background accent */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-299">
        <div className="absolute -top-32 -right-32 w-[600px] h-[600px] bg-brand-gold/8 rounded-full blur-3xl" data-id="element-300"></div>
        <div className="absolute -bottom-32 -left-32 w-[600px] h-[600px] bg-brand-green/6 rounded-full blur-3xl" data-id="element-301"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-302">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16" data-id="element-303">
          {/* LEFT — text */}
          <div className="flex-1 text-center lg:text-left w-full" data-id="element-304">
            {/* Premium badge */}
            <FadeIn data-id="element-305">
              <div className="inline-flex items-center gap-2 bg-brand-green text-white px-5 py-2.5 rounded-full text-xs md:text-sm mb-8 border border-brand-gold/40 tracking-widest uppercase shadow-lg" data-id="element-306">
                <Sparkles className="w-3.5 h-3.5 text-brand-gold" data-id="element-307" />
                <span className="font-bold" data-id="element-308">Sistema Amazon FBA + FBM 2026</span>
              </div>
            </FadeIn>

            {/* Main title — big, clean, lots of breathing room */}
            <FadeIn delay={0.1} data-id="element-309">
              <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-[4.5rem] xl:text-[5rem] font-bold text-brand-green mb-8 tracking-tight leading-[1.05]" data-id="element-310">
                Aprende a vender en Amazon desde cero y desarrolla una{' '}
                <span className="text-brand-gold" data-id="element-311">habilidad digital</span> para
                generar ingresos online
              </h1>
            </FadeIn>

            {/* Subtitle — direct and concrete */}
            <FadeIn delay={0.2} data-id="element-312">
              <p className="text-base sm:text-lg md:text-xl text-brand-text/75 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-313">
                Aprende paso a paso cómo funciona{' '}
                <span className="font-semibold text-brand-green" data-id="element-314">
                  Amazon FBA + FBM
                </span>
                , utiliza{' '}
                <span className="font-semibold text-brand-green" data-id="element-315">
                  Seller Central
                </span>{' '}
                correctamente y descubre cómo miles de personas están comenzando
                a desarrollar ingresos online desde casa incluso sin experiencia
                previa.
              </p>
            </FadeIn>

            {/* Bullets grid */}
            <FadeIn delay={0.3} data-id="element-316">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 mb-10 text-left max-w-2xl mx-auto lg:mx-0" data-id="element-317">
                {bullets.map((bullet, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-318">
                    <div className="w-5 h-5 rounded-full bg-brand-green/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-319">
                      <Check className="w-3 h-3 text-brand-green" strokeWidth={3} data-id="element-320" />
                    </div>
                    <span className="text-sm md:text-base text-brand-text/85 font-medium" data-id="element-321">
                      {bullet}
                    </span>
                  </div>)}
              </div>
            </FadeIn>

            {/* Primary CTA */}
            <FadeIn delay={0.4} data-id="element-322">
              <div className="mb-5" data-id="element-323">
                <Button onClick={goToCheckout} className="w-full sm:w-auto bg-brand-gold hover:bg-brand-gold/90 text-brand-green text-lg md:text-xl font-bold px-12 py-5 shadow-2xl shadow-brand-gold/30 ring-1 ring-brand-gold/40" data-id="element-324">
                  🚀 QUIERO EMPEZAR HOY
                </Button>
              </div>

              {/* Trust badges */}
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-5 gap-y-2 text-brand-text/50 text-xs" data-id="element-325">
                <span className="flex items-center gap-1.5" data-id="element-326">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-327" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-328">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-329" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5" data-id="element-330">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-331" />
                  COMPRA SEGURA
                </span>
                <span className="flex items-center gap-1.5" data-id="element-332">
                  <RefreshCw className="w-3.5 h-3.5 text-brand-green" data-id="element-333" />
                  ACTUALIZADO 2026
                </span>
                <span className="flex items-center gap-1.5" data-id="element-334">
                  <InfinityIcon className="w-3.5 h-3.5 text-brand-green" data-id="element-335" />
                  ACCESO DE POR VIDA
                </span>
              </div>

              <DigitalDisclaimer variant="dark" className="lg:mx-0" data-id="element-336" />
            </FadeIn>
          </div>

          {/* RIGHT — image */}
          <div className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-337">
            <FadeIn delay={0.3} data-id="element-338">
              <div className="relative" data-id="element-339">
                {/* Soft gold glow behind image */}
                <div className="absolute inset-0 bg-brand-gold/15 blur-3xl rounded-3xl scale-95" data-id="element-340"></div>
                <img src="https://cdn.magicpatterns.com/uploads/91JGFMLPCxeBmQ6GN9u4tX/portada_como_vender_en_amazon_comprimida_.png" alt="Cómo Vender en Amazon FBA Desde Cero (2026) - Guía Completa" className="relative w-full h-auto rounded-2xl shadow-[0_30px_80px_-10px_rgba(0,0,0,0.35)] object-contain" data-id="element-341" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}